import { Box, Checkbox, HStack, Text } from '@chakra-ui/react'
import type { FC } from 'react'
import React from 'react'

interface CalendarListItemProps {
  id: string
  name: string
  type: string
  isEnabled: boolean
  onToggle: (id: string, enabled: boolean) => void
  getIcon: (type: string) => React.ReactElement | null
}

export const CalendarListItem: FC<CalendarListItemProps> = ({
  id,
  name,
  type,
  isEnabled,
  onToggle,
  getIcon
}) => {
  const handleContainerClick = () => {
    onToggle(id, !isEnabled)
  }

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // The checkbox onChange already provides the correct checked state
    onToggle(id, e.target.checked)
  }

  return (
    <HStack
      justify="space-between"
      align="center"
      w="full"
      py="4px"
      _hover={{ bg: 'rgba(45, 84, 232, 0.04)' }}
      borderRadius="4px"
      px="8px"
      cursor="pointer"
      onClick={handleContainerClick}
    >
      <HStack spacing="8px" flex={1}>
        <Box
          onClick={e => e.stopPropagation()}
          display="flex"
          alignItems="center"
        >
          <Checkbox
            isChecked={isEnabled}
            onChange={handleCheckboxChange}
            size="md"
            colorScheme="blue"
          />
        </Box>
        <Text
          fontSize="16px"
          fontWeight="400"
          noOfLines={1}
          flex={1}
          userSelect="none"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          maxWidth="146px"
        >
          {name}
        </Text>
      </HStack>
      <Box
        fontSize="16px"
        ml="8px"
        w="16px"
        h="16px"
        display="flex"
        alignItems="center"
      >
        {getIcon(type)}
      </Box>
    </HStack>
  )
}
